module.exports = __webpack_public_path__ + "../resources/images/illustration_balloon-5a7e6cc92b8f6742f6d7bc1f23780654.svg";